import AddressSummaryDisplay from './AddressSummaryDisplay'
import { useCheckoutContext } from 'checkout/containers/CheckoutContextProvider'

const ShippingAddressSummary = () => {
  const { order } = useCheckoutContext()

  if (!order?.shippingAddress) {
    return null
  }

  return <AddressSummaryDisplay {...order.shippingAddress} qaAttr="ShippingAddress" />
}

export default ShippingAddressSummary
